import { hash } from '@ember/helper';
import BvStack from 'volta/components/bv-stack';
import Group from 'volta/components/bv-form-layout/group';
import Item from 'volta/components/bv-form-layout/item';

import type { ComponentLike, ContentValue } from '@glint/template';
import type { BvStackSignature } from 'volta/components/bv-stack';
import type { TOC } from '@ember/component/template-only';
import type { BvFormLayoutGroupSignature } from 'volta/components/bv-form-layout/group';
import type { BvFormLayoutItemSignature } from 'volta/components/bv-form-layout/item';

export interface BvFormLayoutSignature {
  Args: {
    text?: ContentValue;
  };
  Blocks: {
    default: [
      {
        Group: ComponentLike<BvFormLayoutGroupSignature>;
        Item: ComponentLike<BvFormLayoutItemSignature>;
      }
    ];
  };
  Element: BvStackSignature['Element'];
}

const BvFormLayoutComponent: TOC<BvFormLayoutSignature> = <template>
  <BvStack @gap='4' class='bv-form-layout' data-test-bv-form-layout ...attributes>
    {{#if (has-block)}}
      {{yield (hash Group=(component Group) Item=(component Item))}}
    {{else}}
      {{@text}}
    {{/if}}
  </BvStack>
</template>;

export default BvFormLayoutComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvFormLayout: typeof BvFormLayoutComponent;
    'bv-form-layout': typeof BvFormLayoutComponent;
  }
}
